import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import LoginButton from './LoginButton';

const NavBar = () => {
  return (
    <AppBar position="static" sx={{ marginBottom: 2 }}>
      <Toolbar>
        <Typography 
          variant="h6" 
          component="a" 
          href="https://lexinews.com" 
          sx={{ 
            flexGrow: 1,
            textDecoration: 'none',
            color: 'inherit'
          }}
        >
          LexiNews<sup><small>Beta</small></sup>
        </Typography>
        <Box>
          <LoginButton />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar; 